import React from 'react';
import { Plus } from '../../../components/icons';

import styles from './AddCollaboratorCard.module.scss';
type AddCollaboratorCardProps = {
  onClick: () => void;
  label?: string;
};

export const AddCollaboratorCard: React.FC<AddCollaboratorCardProps> = ({ onClick, label }) => (
  <div className={styles['card']} onClick={onClick}>
    <div className={styles['content']}>
      <div className={styles['icon']}>
        <Plus />
      </div>

      {label && <p className={styles['label']}>{label}</p>}
    </div>
  </div>
);
